__turbopack_context__.v({
  "imageBox": "ProductSwiper-module__gmi9Sa__imageBox",
  "imageLink": "ProductSwiper-module__gmi9Sa__imageLink",
  "img": "ProductSwiper-module__gmi9Sa__img",
  "navBtn": "ProductSwiper-module__gmi9Sa__navBtn",
  "nextBtn": "ProductSwiper-module__gmi9Sa__nextBtn",
  "portraitImg": "ProductSwiper-module__gmi9Sa__portraitImg",
  "prevBtn": "ProductSwiper-module__gmi9Sa__prevBtn",
  "productSwiper": "ProductSwiper-module__gmi9Sa__productSwiper",
  "slide": "ProductSwiper-module__gmi9Sa__slide",
  "squareImg": "ProductSwiper-module__gmi9Sa__squareImg",
  "swiperBox": "ProductSwiper-module__gmi9Sa__swiperBox",
  "wideImg": "ProductSwiper-module__gmi9Sa__wideImg",
});
